import { createRequestActions } from '../utils';
import * as productClpTypes from './productClpTypes';

export const fetchProductClpForProduct = createRequestActions(productClpTypes.FETCH_PRODUCT_CLP_FOR_PRODUCT, ProductId => ({
  ProductId,
}));
